import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Create a root instance
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the app within the root
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
